import React from "react";

const ThreeDotsVertical = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <circle className="u_fill" cx={11.2} cy={5.2} r={3.2} fill={fill} />
      <circle className="u_fill" cx={24} cy={5.2} r={3.2} fill={fill} />
      <circle className="u_fill" cx={11.2} cy={18} r={3.2} fill={fill} />
      <circle className="u_fill" cx={24} cy={18} r={3.2} fill={fill} />
      <circle className="u_fill" cx={11.2} cy={30.8} r={3.2} fill={fill} />
      <circle className="u_fill" cx={24} cy={30.8} r={3.2} fill={fill} />
    </svg>
);

export default ThreeDotsVertical;
